import { SET_ANALYTICS_CONNECTED } from '../../../../constants/analytics';

export const setAnalyticsConnected = () => ({
  type: SET_ANALYTICS_CONNECTED,
});
